import { forwardRef } from "react";
import { Text, TextBaseProps } from "./Text";

export const validHeadingTags = ["h1", "h2", "h3"] as const;
type ValidHeadingTag = (typeof validHeadingTags)[number];

const variants = ["heading", "section-heading"] as const;
type Variant = (typeof variants)[number];

export type HeadingProps = { as?: ValidHeadingTag; variant?: Variant } & Omit<
  TextBaseProps,
  "as" | "variant"
>;

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ variant = "section-heading", ...props }: HeadingProps, ref) => (
    <Text variant={variant} {...props} ref={ref} />
  )
);

Heading.displayName = "Heading";
